import { Ability, AbilityBuilder } from '@casl/ability';
import axios, { cachedGet } from '@/helpers/axios';
import store from '@/state/store.js';

const ability = new Ability();

// Define abilities using AbilityBuilder
const { rules } = new AbilityBuilder();

// // Define rules for the Ability instance
// can('read', 'Article');
// // can('add', 'User');
// can('create', 'Article');
// cannot('delete', 'Article');

// Add the defined rules to the Ability instance
ability.update(rules);

export default ability;

/**fetch methods */
export function fetchRoles() {
  const userId = localStorage.getItem('userid');
  const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/settings/user-role/${userId}`;
  return cachedGet(url)
    .then((data) => {
      if (data.data) {
        store.commit('setRoles', data.data.map(item => {
          return {
            role_id: item
          };
        }));
      }
    })
    .catch((error) => {
      console.error('Error fetching roles:', error);
      return null;
    });
}
export function fetchOUAccess() {
  const roles = localStorage.getItem('userRoles') ? JSON.parse(localStorage.getItem('userRoles')).map(item => { return item.role_id; }) : [];
  // console.log(`setRoles`);
  // console.log(roles);
  const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/company`;
  return cachedGet(url, { role_ids: roles, per_page: 1000, assigned: true })
    .then((data) => {
      if (data.data) {
        store.commit('setOUAccess', data.data.map(item => {
          return {
            ou_code: item.company_code,
            ou_name: item.company_name,
            company_id: item.company_id,
            station_codes: item.station_codes || [],
            address_street: item.address_street || '',
            address_brgy: item.address_brgy || '',
            address_city: item.address_city || '',
            address_province: item.address_province || '',
            address_country: item.address_country || '',
          };
        }));
      }
    })
    .catch((error) => {
      console.error('Error fetching menu:', error);
      return null;
    });
}
export function fetchPermissions() {
  return cachedGet(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/permissions`)
    .then((data) => {
      if (data.data) {
        console.log('permission loaded');
        store.commit('setPermissions', data.data.map(item => { return item.code; }));
      }
    }).catch((error) => {
      console.error('Error fetching permissions:', error);
    });
}
